import React, { useEffect } from "react";
import { Popconfirm, Space, Table } from "antd";
import strings from "../../utils/strings";
import AddCompanyWage from "./AddCompanyWage";
import EditCompanyWage from "./EditCompanyWage";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useNonePersistedStore } from "../../store/non-persisted-store";
import { usePersistedStore } from "../../store/persisted-store";

export default function CompanyDefaultWages({companyWagesId}) {
 
    const general = useGeneralStore();
    const { getCompanyDefaultAgentWage, deleteCompanyDefaultWage, wages } = useNonePersistedStore()
    const { business } = usePersistedStore()
    const compmanyDefaultAgentWages = wages.companyDefaultWage;
    const compmanyDefaultAgentWagesLoading = wages.loading;
    const businessName = business.currentBusiness?.name;


    useEffect(() => {
        if (businessName || companyWagesId === 2)
            getCompanyDefaultAgentWage();
    }, [businessName])

    const columns = [
        {
            title: "شرکت بیمه",
            dataIndex: "CompanyName",
            key: "CompanyName",
            ellipsis: true,
            render: (text) => <span style={{ color: "#5ec393" }}>{text}</span>,
        },

        {
            title: "رشته بیمه",
            dataIndex: "BranchName",
            key: "BranchName",
            ellipsis: true,
            render: (text) => <span style={{ color: "#5ec393" }}>{text}</span>
        },
        {
            title: "درصد کارمزد",
            dataIndex: "DefaultAgentWagePercent",
            key: "DefaultAgentWagePercent",
            sorter: (a, b) => a.DefaultAgentWagePercent.localeCompare(b.DefaultAgentWagePercent),
            render: (text) => text && <span style={{ color: "#f00000" }}>{strings.getFarsiNum(text)} %</span>
        },
        {
            title: "مبلغ کارمزد",
            dataIndex: "DefaultAgentWagePrice",
            key: "DefaultAgentWagePrice",
            sorter: (a, b) => a.DefaultAgentWagePrice.localeCompare(b.DefaultAgentWagePrice),
            render: (text) => text && <span style={{ color: "#f00000" }}>{strings.currencyFormat(text)} ريال</span>
        },
        {
            title: "",
            dataIndex: "operation",
            key: "operation",
            ellipsis: true,
            render: (_, record) =>
                compmanyDefaultAgentWages.length > 0 && (
                    <Space size="middle">
                        <Popconfirm
                            title="آیا از حذف مطمئن هستید؟"
                            onConfirm={() => deleteCompanyDefaultWage(record.CompanyBranchId)}>
                            <button type="link" className="btn btn-danger btn-sm waves-effect waves-light">
                                <i className="fas fa-minus font-size-16 align-middle mr-2"></i> حذف
                            </button>
                        </Popconfirm>
                        <button type="link" className="btn btn-primary btn-sm waves-effect waves-light"
                            onClick={() => {
                                general.ToggleEditCompanyDefaultAgentModal();
                                getCompanyDefaultAgentWage(record.CompanyBranchId);
                            }}>
                            <i className="fas fa-edit font-size-16 align-middle mr-2"></i> ویرایش
                        </button>
                    </Space>
                ),
        },
    ];

    return (
        <div>
            <button type="primary" className="btn btn-primary waves-effect waves-light float-left"
                onClick={() => general.ToggleCompanyDefaultAgentModal()} style={{ marginBottom: "20px" }}>
                <i className="fas fa-plus font-size-14 align-middle mr-2"></i>افزودن شرکت جدید
            </button>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                scroll={true}
                bordered
                columns={columns}
                loading={compmanyDefaultAgentWagesLoading}
                rowKey="CompanyBranchId"
                dataSource={compmanyDefaultAgentWages}
            />
            <AddCompanyWage />
            <EditCompanyWage />
        </div>
    )

}
